import fetchPhraseIfNeeded from 'helpers/utils/fetch-phrase-if-needed';
import { getLists } from 'adapters/list';
import {
    ADD_ITEMS_REQUEST,
    ADD_REQUEST,
    FavouritesPayload,
    UPDATE_DATA,
    UpdateDataEvent,
    UpdateDataPayload,
} from 'helpers/pubsub';
import { addToList } from './addToList';
import { List } from 'adapters/list/graphqlTypes';
import { updateMultiListStore } from 'helpers/store';
import { reportError } from 'helpers/sentry';

const handleAddToListSubscription = (payload: FavouritesPayload) => {
    return Promise.all([
        import('./bootAddToList'),
        getLists(),
        fetchPhraseIfNeeded(),
    ])
        .then(([{ boot }, res]) => {
            if (res.data.lists.length <= 1 && !payload.alwaysShowModal) {
                return addToList(payload);
            }
            boot(payload, res.data.lists as List[]);
        })
        .catch(e => {
            reportError(e as Error);
        });
};

const handleUpdateDataSubscription = (payload: UpdateDataPayload) => {
    if (payload.source === 'favourites') {
        updateMultiListStore(payload.data);
    }
};

export const initAddToList = () => {
    window.ikea.pubsub.subscribe(ADD_REQUEST, handleAddToListSubscription);
    window.ikea.pubsub.subscribe(
        ADD_ITEMS_REQUEST,
        handleAddToListSubscription
    );
    window.ikea.pubsub.subscribe<UpdateDataEvent>(
        UPDATE_DATA,
        handleUpdateDataSubscription
    );
};
